// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__cL1U-","box":"style_box__yXXMf","active":"style_active__+0vsR","title":"style_title__964w+","item":"style_item__vAh1j"};